import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Checkbox from "@shared/v2/Checkbox";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import TextButton from "@shared/v2/TextButton";

const AboutWebsiteProfilesModal = ({ show, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="About Website Profiles" closeButton />
    <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
      <Typography variant="body-m">
        Website Profiles are members of your team that you want to display on your website, but do not have
        access to the CRM.
      </Typography>

      <Typography variant="body-m">
        Perfect for listing photographers, stagers, administrative staff, and even those team mascots! 🐶🐱
      </Typography>

      <Checkbox
        onChange={(e) => localStorage.setItem("websiteRoster:hideAboutModal", e.target.checked)}
        label="Don't show me this again"
      />
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="tertiary" onClick={() => onClose(false)}>
        Cancel
      </Button>
      <div className="tw-flex tw-items-center tw-gap-[8px]">
        <TextButton size="medium">Learn More</TextButton>
        <Button size="medium" onClick={() => onClose(true)}>
          Got It
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

AboutWebsiteProfilesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AboutWebsiteProfilesModal;
